import Vue from 'vue'
import $updateFile from '@/assets/js/uploadFile'

const imgUrl = {
  state: {
    logoUrl: {},
    jobFairUrl: {}
  },
  mutations: {
    setLogoUrl: (state, data) => { // 正式时 portrait替换成enterpriseLogo
      if (!state.logoUrl[data['id']] && data['key']) {
        $updateFile('enterpriseLogo', data['key'], url => {
          Vue.set(state.logoUrl, 'id_' + data.id, url)
        }, 1)
      }
    },
    setJobFairUrl: (state, data) => {
      if (!state.jobFairUrl[data['id']] && data['key']) {
        $updateFile('jobFair', data['key'], url => {
          Vue.set(state.jobFairUrl, 'id_' + data.id, url)
        }, 1)
      }
    }
  },
  actions: {}
}

export default imgUrl



// WEBPACK FOOTER //
// ./src/store/imgUrl.js